import { appStorage } from "../storage";
import {ACCESS_TOKEN, API_GOOGLE_AUTOCOMPLETE} from "@/shared/constant";
import {EnumOption} from "@/interfaces/common";
import { pick, get, intersection, toNumber } from 'lodash';
import {ParamAutocomplete} from "@/shared/components/CustomGoogleAutoComplete/paramautocomplete";
import XLSX from 'xlsx';
import Axios from "axios";
import {message} from "ant-design-vue";

const buildRequestHeader = (contentType = "application/json") => {
    const result: any = {
        "Authorization": `Bearer ${appStorage.get(ACCESS_TOKEN) || ""}`,
        "Accept": "application/json",
        "target": 2,
        'devicetoken': `${appStorage.get('devicetoken') || ""}`,
        'os': 1
    };
    if (contentType)
        result["Content-Type"] = contentType;
    return result
};

const setPageTitle = (title = "Logistic Admin") => document.title = title;

const enumToOptions = (data: any): EnumOption[] => {
    const result: EnumOption[] = [];
    Object.keys(data).forEach(k => {
        try {
            const value = Number(k);
            if (value || value === 0) {
                result.push({
                    label: data[value],
                    value
                });
            }
        } catch (e) {
        }
    });
    return result;

};

const assignValueToForm = (form: any, data: any) => {
    const fields = Object.keys(form);
    const pickedData = pick(data, fields);
    return { ...{...form}, ...pickedData };
};

const filterData = (data: any) => {
    return Object.keys(data)
        .filter(key => data[key] !== null && data[key] !== undefined)
        .reduce((result, key) => ({...result, [key]: data[key]}), {});
};

const getPublicPath = () => {
    return process.env.NODE_ENV === 'production'
        ? '/'
        : '/'
};

const getLocationFromPlaceDetail = (placeDetail: any) => {
    const locationKeys = {
        country: ["country"],
        province: ["administrative_area_level_1"],
        district: ["administrative_area_level_2", "locality"],
        ward: ["sublocality_level_1"]
    };
    const addressComponents = get(placeDetail, 'address_components', []);
    const country = addressComponents.find((item: any) => intersection(item.types, locationKeys.country).length)?.long_name;
    const province = addressComponents.find((item: any) => intersection(item.types, locationKeys.province).length)?.long_name;
    const district = addressComponents.find((item: any) => intersection(item.types, locationKeys.district).length)?.long_name;
    const ward = addressComponents.find((item: any) => intersection(item.types, locationKeys.ward).length)?.long_name;
    return { country, province, district, ward };
};

const generateRequestUrlGoogleAutoComplete = (params: ParamAutocomplete) => {
    return `${API_GOOGLE_AUTOCOMPLETE}?input=${params.input}&key=${params.key}&language=${params.language}&components=${params.components}&sessiontoken=${params.sessiontoken}`
};

const getValuesEnum = (instance: any) => {
    const result: any = [];
    Object.keys(instance).forEach(k => {
        try {
            if (typeof instance[k as any] === "number") {
                result.push(instance[k])
            }
        } catch (e) {
        }
    });

    return result;
}

function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

function sheet2blob(sheet, sheetName) {
    sheetName = sheetName || 'sheet1';
    const workbook = {
        SheetNames: [sheetName],
        Sheets: {}
    };
    workbook.Sheets[sheetName] = sheet; // Generate excel configuration items

    const wopts: any = {
        bookType: 'xlsx', // file type to generate
        bookSST: false, // Whether to generate a Shared String Table, the official explanation is that if the startup speed will decrease, but there is better compatibility on the lower version of the IOS device
        type: 'binary',
        compression: true
    };
    const wbout = XLSX.write(workbook, wopts);
    const blob = new Blob([s2ab(wbout)], {
        type: "application/octet-stream"
    }); // string to ArrayBuffer
    return blob;
}

function openDownloadDialog(url, saveName) {
    if (typeof url == 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url); // Create a blob address
    }
    const aLink = document.createElement('a');
    aLink.href = url;
    aLink.download = saveName || ''; // HTML5 new attribute, specify the save file name, you can not suffix, note that file:/// mode will not take effect
    let event;
    if (window.MouseEvent) event = new MouseEvent('click');
    else {
        event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    }
    aLink.dispatchEvent(event);
}

function normalizeField(val: any) {
    return val?.normalize('NFD');
}

function downloadFile(data, filename, mime?, bom?) {
    const blobData = (typeof bom !== 'undefined') ? [bom, data] : [data]
    const blob = new Blob(blobData, {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        const blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();

        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200)
    }
}

function downloadFromUrl(url: string, fileName: string) {
    Axios.get(url, {
        responseType: 'blob',
    }).then(res => {
        downloadFile(res.data, fileName);
    }).catch(error => {
        message.error("Không tồn tại ảnh");
    });
}

function toSlug(input: string, whitespace = '-') {
    if (!input) return input;
    return input
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .replace(/Đ/g, "D")
        .trim()
        .replace(/\s/g, whitespace)
        .replace(/[&/\\#,+$~%.'":*?<>{}]/g, whitespace)
}

function getValidQuery(data: any) {
    const result = {} as any;
    Object.keys(data).forEach((key: string) => {
        result[key] = (data[key]) ? (toNumber(data[key]) || data[key]) : data[key]
    })
    return result;
}

function replacePrefixRegion(name: string) {
    if (!name) return name;
    const nameTrue = name.toLocaleLowerCase();
    let result = nameTrue;
    const prefixs = [/^tỉnh/g, /^thành phố/g, /^quận/g, /^huyện/g, /^phường/g, /^xã/g];
    prefixs.forEach((prefix) => {
        if (result === nameTrue)
            result = result.replace(prefix, "").trim();
    })
    return result
}


async function getDataSequentially(promiseFunction, params): Promise<any> {
    try {
        let results: any[] = [];
        const { data } = await promiseFunction(params);
        results = [...results, ...data.datas];
        for (let i = 2; i <= data?.meta?.totalPage; i++) {
            const { data } = await promiseFunction({ ...params, page: i });
            results = [...results, ...data.datas];
        }
        return results;
    } catch (e) {
    }
}

function getEnumKeyByEnumValue(myEnum: any, enumValue: number | string): string {
    const keys = Object.keys(myEnum).filter((x) => myEnum[x] == enumValue);
    return keys.length > 0 ? keys[0] : '';
}

export {
    buildRequestHeader,
    setPageTitle,
    enumToOptions,
    assignValueToForm,
    filterData,
    getPublicPath,
    getLocationFromPlaceDetail,
    generateRequestUrlGoogleAutoComplete,
    getValuesEnum,
    sheet2blob,
    openDownloadDialog,
    normalizeField,
    downloadFromUrl,
    toSlug,
    getValidQuery,
    replacePrefixRegion,
    getDataSequentially,
    getEnumKeyByEnumValue
};

